import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ASSETS_QUERY_KEY, RESOURCE_USAGES_QUERY_KEY} from "../queryKeys";
import {ReachAsset, ReachAssetUpdatePayload} from "./types";

type UpdateAssetVariables = ReachAssetUpdatePayload & {id: number};

const updateAsset = async ({id, ...payload}: UpdateAssetVariables): Promise<ReachAsset> => {
  const response = await axiosReachInstance.put<ReachAsset, AxiosResponse<ReachAsset>, ReachAssetUpdatePayload>(
    `/assets/${id}`,
    payload
  );
  return response.data;
};

export const useUpdateAsset = (
  options?: BaseMutationOptions<ReachAsset, UpdateAssetVariables>
): BaseUseMutationResult<ReachAsset, UpdateAssetVariables> => {
  return useBaseMutation<ReachAsset, UpdateAssetVariables>(updateAsset, {
    ...options,
    prefixKeysToInvalidate: () => [[ASSETS_QUERY_KEY], [RESOURCE_USAGES_QUERY_KEY]],
  });
};
